import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'

import {
  fetchInventoryOrder,
  getInventoryOrder,
  getInventoryOrdersIsFetching,
} from '~/store/duck/inventoryOrders'
import { getInventoryItemDisplayName } from '~/utils/inventoryItemUtils'

import { OrderItemReceiptsPage } from './order-item-receipts/OrderItemReceiptsPage'
import { OrderItemsPage } from './order-items/OrderItemsPage'
import { OrderItemsPageBreadcrumbs } from './order-items/OrderItemsPageBreadcrumbs'

export const InventoryOrdersPage = () => {
  const { orderId, itemId } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isInitialized, setIsInitialized] = useState(false)

  const isFetching = useSelector(getInventoryOrdersIsFetching)
  const inventoryOrder = useSelector(getInventoryOrder(orderId))
  const inventoryOrderItem = inventoryOrder?.items.find(
    ({ id }) => id === itemId,
  )

  const showOrderItemsPage = inventoryOrder && !inventoryOrderItem
  const showReceiptsPage = inventoryOrder && inventoryOrderItem
  const shouldNavToOrders =
    isInitialized && !showOrderItemsPage && !showReceiptsPage

  useEffect(() => {
    if (isFetching) {
      return
    }

    if (!isInitialized && orderId && !inventoryOrder) {
      dispatch(fetchInventoryOrder(orderId))
      setIsInitialized(true)
    } else if (shouldNavToOrders) {
      navigate('/admin/catalog/inventories/orders')
    }
  }, [
    orderId,
    inventoryOrder,
    isInitialized,
    isFetching,
    dispatch,
    navigate,
    shouldNavToOrders,
  ])

  if (isFetching || (!showOrderItemsPage && !showReceiptsPage)) {
    return <CircularProgress sx={{ m: 'auto' }} />
  }

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <OrderItemsPageBreadcrumbs
        itemName={getInventoryItemDisplayName(
          inventoryOrderItem?.inventoryItem,
        )}
        orderId={inventoryOrder.id}
        orderNumber={inventoryOrder.orderNumber}
      />
      {showOrderItemsPage && <OrderItemsPage inventoryOrder={inventoryOrder} />}
      {showReceiptsPage && (
        <OrderItemReceiptsPage
          inventoryOrder={inventoryOrder}
          inventoryOrderItem={inventoryOrderItem}
        />
      )}
    </Box>
  )
}
